import React from 'react';
import { Field, FieldProps } from 'formik';
import { useCurrentSubscriptions } from '../../queries';

interface Props<T extends Partial<{ id: string }>> {
  onClick?: (offer: T) => any;
  name?: string;
  selected?: string;
  children: (params: {
    onClick?: (offer: T) => any;
    selected: boolean;
    selectMode: boolean;
  }) => React.ReactNode;
  offerId: string;
  defaultSubscription?: boolean;
}

export const OfferActionProvider = <T extends Partial<{ id: string }>>({
  onClick,
  name,
  offerId,
  children,
  defaultSubscription,
  selected,
}: Props<T>) => {
  const { data: subscriptions } = useCurrentSubscriptions();

  if (name) {
    return (
      <Field name={name}>
        {({ field, form }: FieldProps) =>
          children({
            onClick: (offer: T) => {
              form.setFieldValue(name, offer.id);
              if (onClick) {
                onClick(offer);
              }
            },
            selected: field.value === offerId,
            selectMode: true,
          })
        }
      </Field>
    );
  }

  return (
    <>
      {children({
        onClick,
        selectMode: false,
        selected: selected
          ? selected === offerId
          : !!subscriptions?.some(
              (s) => s.offerId === offerId && !s.cancelAt,
            ) ||
            (!subscriptions?.length && !!defaultSubscription),
      })}
    </>
  );
};
